"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokenFromAuthUi = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _lcHttp = _interopRequireDefault(require("lc-http"));
var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));
var _ChatBot = _interopRequireDefault(require("./ChatBot.styles"));
var _authConstants = require("../../configs/authConstants");
var _constants = _interopRequireDefault(require("../../configs/constants"));
var _scriptConstants = _interopRequireDefault(require("../../configs/scriptConstants"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getTokenFromAuthUi = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _lcHttp.default)({
            method: 'post',
            url: "".concat(_authConstants.AUTH_UI_CHAT_LOGIN_BASE_URL).concat(_authConstants.GET_TOKEN_PATH),
            headers: {
              Client: _authConstants.FIVE9_CLIENT
            },
            // Cookie will be passed in the request. auth-ui is looking for janus token specifically.
            withCredentials: true
          });
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          throw _context.t0;
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function getTokenFromAuthUi() {
    return _ref.apply(this, arguments);
  };
}();
exports.getTokenFromAuthUi = getTokenFromAuthUi;
function ChatBot(_ref2) {
  var _config$messenger, _config$messenger$cus, _config$messenger2;
  var config = _ref2.config,
    isProactive = _ref2.isProactive,
    proactiveTime = _ref2.proactiveTime,
    onError = _ref2.onError,
    fetchJWTTokenEnabled = _ref2.fetchJWTTokenEnabled;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isMessengerReady = _useState2[0],
    setIsMessengerReady = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var brandColor = config === null || config === void 0 ? void 0 : (_config$messenger = config.messenger) === null || _config$messenger === void 0 ? void 0 : (_config$messenger$cus = _config$messenger.customColors) === null || _config$messenger$cus === void 0 ? void 0 : _config$messenger$cus.brandColor;
  var _useStyles = (0, _ChatBot.default)({
      backgroundColor: brandColor ? "#".concat(brandColor) : null
    }),
    chatBotButton = _useStyles.chatBotButton;
  var triggerButtonClick = function triggerButtonClick() {
    var iframeEl = document.querySelector('#web-messenger-container');
    if (iframeEl) {
      var buttonEl = iframeEl.contentWindow.document.querySelector('#messenger-button');
      buttonEl.click();
    }
  };
  var onMessengerReady = function onMessengerReady() {
    setIsLoading(false);
    setIsMessengerReady(true);
    triggerButtonClick();
  };
  var fetchErrorStatusCode = function fetchErrorStatusCode(err) {
    var _err$response;
    var statusCode = err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status;
    if (statusCode) {
      switch (statusCode) {
        case 403:
          return _authConstants.AUI_403_UNTRUSTED_HOST;
        case 404:
          return _authConstants.AUI_404_INVALID_HEADER;
        case 500:
          return _authConstants.AUI_500_SERVICE_ERROR;
        default:
          break;
      }
    }
    return _authConstants.AUI_GENERIC_ERROR;
  };

  /**
   * Given a user's session (look for 'janus' in session cookie),
   * call auth-ui to fetch a JWT Token. Verify the JWT token again
   * with auth-ui and push the token to the Five9 Chat Widget config
   * (under prepopulatedFields).
   *
   * JWT Token can be used by Five9 to grab additional borrower/member information.
   */
  var populateJWTToken = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var tokenResponse, _tokenResponse$data, jwtToken, prepopulatedFields;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getTokenFromAuthUi();
          case 2:
            tokenResponse = _context2.sent;
            // eslint-disable-next-line no-unsafe-optional-chaining
            _tokenResponse$data = tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.data, jwtToken = _tokenResponse$data.access_token;
            if (jwtToken) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return");
          case 6:
            prepopulatedFields = config.prepopulatedFields;
            if (prepopulatedFields) {
              prepopulatedFields.push({
                k: 'Token',
                v: jwtToken
              });
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function populateJWTToken() {
      return _ref3.apply(this, arguments);
    };
  }();
  var onScriptLoad = function onScriptLoad() {
    window.F9.Chat.Wrapper.messenger.on('messenge:ready', onMessengerReady);
    window.F9.Chat.Wrapper.init(config);
  };
  var loadScript = function loadScript() {
    var script = document.createElement('script');
    script.src = _scriptConstants.default.url;
    script.id = 'chat-bot-script';
    script.onload = onScriptLoad;
    document.body.appendChild(script);
  };
  var initChatBot = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setIsLoading(true);
            if (!fetchJWTTokenEnabled) {
              _context3.next = 10;
              break;
            }
            _context3.prev = 2;
            _context3.next = 5;
            return populateJWTToken();
          case 5:
            _context3.next = 10;
            break;
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](2);
            onError(fetchErrorStatusCode(_context3.t0));
          case 10:
            loadScript();
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 7]]);
    }));
    return function initChatBot() {
      return _ref4.apply(this, arguments);
    };
  }();
  var initProactiveChat = function initProactiveChat() {
    setTimeout(function () {
      if (!isLoading && !isMessengerReady) {
        initChatBot();
      }
    }, proactiveTime);
  };
  (0, _react.useEffect)(function () {
    if (isProactive) {
      initProactiveChat();
    }
  }, [isProactive]);
  if (isMessengerReady) {
    return null;
  }
  var buttonIconUrl = (config === null || config === void 0 ? void 0 : (_config$messenger2 = config.messenger) === null || _config$messenger2 === void 0 ? void 0 : _config$messenger2.buttonIconUrl) || _constants.default.messenger.buttonIconUrl;
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: chatBotButton,
    onClick: initChatBot,
    disabled: isLoading,
    id: "chat-bot-button",
    "aria-label": "open chat"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, null) : /*#__PURE__*/_react.default.createElement("img", {
    src: buttonIconUrl,
    alt: "open chat"
  }));
}
var _default = ChatBot;
exports.default = _default;
ChatBot.propTypes = {
  config: (0, _propTypes.shape)({
    cdn: _propTypes.string,
    useBusinessHours: _propTypes.bool,
    languages: (0, _propTypes.shape)({
      enabled: _propTypes.bool,
      backgroundColor: _propTypes.string
    }),
    l10n: (0, _propTypes.shape)({
      en: (0, _propTypes.shape)({
        messenger: (0, _propTypes.shape)({
          customText: (0, _propTypes.shape)({})
        }),
        systemMessages: (0, _propTypes.shape)({
          transferredToParticipant: _propTypes.string,
          transferredToGroup: _propTypes.string
        }),
        captureFields: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
          k: _propTypes.string,
          l: _propTypes.string,
          p: _propTypes.string
        }))
      })
    }),
    prepopulatedFields: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      k: _propTypes.string,
      v: _propTypes.string
    })),
    messenger: (0, _propTypes.shape)({
      integrationId: _propTypes.string,
      soundNotificationEnabled: _propTypes.bool,
      transcriptPrintingEnabled: _propTypes.bool,
      menuItems: (0, _propTypes.shape)({
        imageUpload: _propTypes.bool,
        fileUpload: _propTypes.bool,
        shareLocation: _propTypes.bool
      }),
      embedded: _propTypes.bool,
      businessName: _propTypes.string,
      businessIconUrl: _propTypes.string,
      buttonIconUrl: _propTypes.string,
      browserStorage: _propTypes.string,
      fixedHeader: _propTypes.bool,
      displayStyle: _propTypes.string,
      customColors: (0, _propTypes.shape)({
        brandColor: _propTypes.string,
        conversationColor: _propTypes.string,
        actionColor: _propTypes.string
      })
    }),
    clearMessagesTimeout: _propTypes.number
  }),
  isProactive: _propTypes.bool,
  proactiveTime: _propTypes.number,
  onError: _propTypes.func,
  fetchJWTTokenEnabled: _propTypes.bool
};
ChatBot.defaultProps = {
  config: {},
  isProactive: false,
  proactiveTime: 0,
  onError: function onError() {},
  fetchJWTTokenEnabled: false
};
